import { Divider, Tooltip } from 'antd'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { NeUploadErrorIcon } from '@eastcoal/icon/NeUploadErrorIcon'

import { AttachmentItem } from '../Item'
import { useAttachmentCardStore } from '../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  attachementError: {
    padding: `${token.paddingXS}px ${token.paddingSM}px`,
    borderRadius: token.borderRadiusXS,
    backgroundColor: token.colorErrorBg
  },
  errorIcon: {
    fontSize: 20
  }
}))

export const AttachmentError = () => {
  const { error, filename } = useAttachmentCardStore(state =>
    pick(state, ['error', 'filename'])
  )

  const { styles } = useStyles()

  return (
    <Tooltip color='red' title={error}>
      <AttachmentItem
        className={styles.attachementError}
        icon={<NeUploadErrorIcon className={styles.errorIcon} />}
        filename={
          <>
            文件上传失败，请重试 <Divider orientation='vertical' /> {filename}
          </>
        }
      />
    </Tooltip>
  )
}
